








































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { maskDate, maskHour } from '@/utils/common'

@Component
export default class ModalLogsPrestadorRecebimento extends Vue {
  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get showModal() {
    return this.getFinanceiroStore.modal.logsPrestadorRecebimento
  }

  set showModal(value: boolean) {
    this.getFinanceiroStore.setModal({ name: 'logsPrestadorRecebimento', value })
  }

  get logs() {
    return this.getFinanceiroStore.logsPrestadorRecebimento
  }

  get recebimento() {
    return this.getFinanceiroStore.prestadorRecebimento
  }

  dateTimeMask(log: any) {
    const date = log.createdOn
    if (!date) return 'Não informado'
    return `${maskDate(date)} ${maskHour(date)}`
  }

  isSuccess(log: any) {
    if (typeof log.sucesso === 'boolean') return log.sucesso
    return false
  }

  close() {
    this.getFinanceiroStore.setModal({ name: 'logsPrestadorRecebimento', value: false })
  }
}
